import Axios from "axios";

const global = {
  // https://test-xlkx.youliao.com
  // http://10.2.1.148:8001
  baseUrl: process.env.VUE_APP_BASE_URL,
  baseSsoUrl: ``,
};

const myAxios = Axios.create({
  // baseURL: global.baseUrl,
  timeout: 180000, // 请求超时时间
});

// 请求拦截器
myAxios.interceptors.request.use(
  request => {
    if (request.params) {
      const params = request.params;
      delete params.noLoading;
      request.params = params;
    }
    request.headers["Content-Type"] = "application/json";
    // request.headers.app = 1;
    // request.headers.platform = 1;
    // request.headers.route = vue.$route.path;
    return request;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
myAxios.interceptors.response.use(
  response => {
    if (response.config.params) {
      const params = response.config.params;
      delete params.noLoading;
      response.config.params = params;
    }
    return response.data;
  },
  error => {
    return Promise.reject(error);
  }
);

const http = {
  async get(url, params) {
    return await myAxios({
      url: `${global.baseUrl}/${url}`,
      method: "get",
      params,
    });
  },
  async getCode(url, params) {
    return await myAxios({
      url: `${global.baseUrl}/${url}`,
      method: "get",
      params,
      responseType: "arraybuffer",
    });
  },
  async post(url, data) {
    return await myAxios({
      url: `${global.baseUrl}/${url}`,
      method: "post",
      data,
    });
  },
};

export default http;
